
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/instagram-marketing-services",
      function () {
        return require("private-next-pages/instagram-marketing-services/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/instagram-marketing-services"])
      });
    }
  